// Props builders for the feature-usage events (tracking plan goal G2).

export type AxiSurface =
  | 'assistant'
  | 'recommendation'
  | 'lesson_learning_mode'
  | 'post_exam'
  | 'results'
  | 'worked_solution'
  | 'ask_axi_guest'
  | 'solution_bank_guest'

export interface IAxiMessage {
  surface: AxiSurface
  conversationId?: string | null
  // Learner messages already in the conversation before this one.
  priorUserMessages: number
  hasImage: boolean
  isGuest: boolean
  carriedFrom?: 'ask_axi' | 'solution_bank' | 'wp_card' | null
}

export function axiMessageSentProps(message: IAxiMessage) {
  return {
    surface: message.surface,
    conversationId: message.conversationId ?? null,
    isFirstMessage: message.priorUserMessages === 0,
    hasImage: message.hasImage,
    isGuest: message.isGuest,
    carriedFrom: message.carriedFrom ?? null,
  }
}

export function isFirstLessonCompletion(
  lessonId: string | null | undefined,
  completedLessonIds: readonly string[],
): boolean {
  return !!lessonId && !completedLessonIds.includes(lessonId)
}

export interface IExamSimulationEnd {
  paperId: string
  endedBy: 'submit' | 'timeout' | 'stop'
  answeredCount: number | null
  startedAtMs: number | null
  endedAtMs: number
}

export function examSimulationCompletedProps(end: IExamSimulationEnd) {
  return {
    paperId: end.paperId,
    endedBy: end.endedBy,
    answeredCount: end.answeredCount,
    elapsedMinutes:
      end.startedAtMs === null
        ? null
        : Math.round((end.endedAtMs - end.startedAtMs) / 60_000),
  }
}
